import type { SpecChapter } from '../types';

export const ReportParagraphsService = Symbol.for('ReportParagraphsService');

export interface ReportParagraphsService {
    /**
     * 获取章节和段落
     */
    getChaptersAndParagraphs(): Promise<SpecChapter[]>;
}
